export enum HEADER_THEME {
    DARK = 'dark',
    LIGHT = 'light',
    PURPLE = 'purple',
  }
